import React from 'react';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocScheduleGlobalRoute } from '@jira/router-routes__eoc-schedule-global-routes/src/eocScheduleGlobalRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { resources as scheduleGlobalResources } from '@atlassian/eoc-schedule-global/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const LazyScheduleGlobalPage = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-schedule-global", jiraSpaEntry: "async-jira-eoc-schedule-global" */ '@jira/eoc__schedule-global/src/ui/index.tsx'
	).then((m) => m.ScheduleGlobalPage),
);

const EocScheduleGlobalComponent = () => (
	<LazyPage
		Page={LazyScheduleGlobalPage}
		pageId="async-jira-eoc-schedule-global"
		shouldShowSpinner={false}
	/>
);

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const eocScheduleGlobalRouteEntry: Route = createEntry(eocScheduleGlobalRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: EocScheduleGlobalComponent,
	layout: opsSettingsLayout,

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		...scheduleGlobalResources(),
		getConsolidationStateResource(),
	] as RouteResources,

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyScheduleGlobalPage],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
